export function oversToBalls(overs) {
  if (overs === null || overs === undefined || overs === "") return 0;
  const s = String(overs);
  if (s.includes(".")) {
    const [whole, part] = s.split(".");
    let ball = part ? parseInt(part[0], 10) : 0;
    if (isNaN(ball)) ball = 0;
    ball = Math.min(Math.max(ball, 0), 5);
    return (parseInt(whole || "0", 10) || 0) * 6 + ball;
  }
  return (parseInt(s, 10) || 0) * 6;
}

export function ballsToOvers(balls) {
  if (!balls) return "0.0";
  return `${Math.floor(balls / 6)}.${balls % 6}`;
}

const num = (v) => (v === null || v === undefined || v === "" ? 0 : Number(v));
const fmt = (v, d = 1) => (v === null || v === undefined || isNaN(v) ? "-" : Number(v).toFixed(d));

export function battingDerived(b = {}) {
  const runs = num(b.runs), balls = num(b.balls), fours = num(b.fours), sixes = num(b.sixes), dots = b.dots;
  const boundaryRuns = fours * 4 + sixes * 6;
  const sr = balls ? (runs / balls) * 100 : null;
  const bpct = runs ? (boundaryRuns / runs) * 100 : null;
  const dpct = dots !== undefined && dots !== "" && balls ? (num(dots) / balls) * 100 : null;
  return { strike_rate: fmt(sr), boundary_pct: fmt(bpct), dot_pct: fmt(dpct), boundaryRuns };
}

export function bowlingDerived(bw = {}) {
  const balls = bw.balls_override ? num(bw.balls_override) : oversToBalls(bw.overs);
  const runs = num(bw.runs_conceded), wickets = num(bw.wickets), dots = bw.dots;
  const econ = balls ? runs / (balls / 6) : null;
  const dpct = dots !== undefined && dots !== "" && balls ? (num(dots) / balls) * 100 : null;
  return { economy: fmt(econ, 2), dot_pct: fmt(dpct), balls };
}
